import React, { useState, useEffect } from "react";
import { Carousel } from "primereact/carousel";

import Chart from "chart.js/auto";
import axios from "axios";

// import "../dashboardStyle/dash.css";

import { DashStk } from "./DashStockage/dashStockage";

import { DashRetard } from "./DashRetard/dashRetard";
import { DashRetard2 } from "./DashRetard/dashRetard2";

import { LineChart22 } from "./dashPeriodique/dashPeriode22";
import { LineChart23 } from "./dashPeriodique/dashPeriode23";
import { LineChart24 } from "./dashPeriodique/dashPeriode24";

import { DoughnutChartFiche } from "./fiche/fiche";
import { DoughnutChartFicheDem } from "./fiche/ficheDem";

import MailStatsChart from "./MailsStats/stockMailsChart";
import DemMailStatsChart from "./MailsStats/demMailsChart";


import { OccupationStats } from "./DashStockage/OccupationStats";

import { DashStkTout } from "./DashStockage/dashPrincStoc";
import { DashRDC } from "./DashStockage/dashRDC";
import { DashETG } from "./DashStockage/dashEtage";
import { DashConteneurs } from "./DashStockage/dashConteneurs";

import { Box, fontStyle } from "@mui/system";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import useMediaQuery from "@mui/material/useMediaQuery";
export const Dash = () => {
    const apiUrl = process.env.REACT_APP_API_URL;

  const [value, setValue] = React.useState("1");

  const isMobilePortrait = useMediaQuery("(max-width:1207px) ");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

 const cardBaseStyle = {
  background: "#fff",
  borderRadius: "5px",
  boxShadow: "0 1px 1px rgba(0,0,0,0.01)",
  padding: "5px",
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
};

const cardTitleStyle = {
  fontWeight: 600,
  fontSize: "14px",
  marginBottom: "5px",
  color: "#333",
  borderBottom: "1px solid #eee",
  paddingBottom: "10px",
};


 // États pour les locations
  const [totalLocation, setTotalLocation] = useState(0);
  const [retardLocation, setRetardLocation] = useState(0);

  // États pour les stockages totaux
  const [totalStockages, setTotalStockages] = useState(0);
  const [stockagesOccupes, setStockagesOccupes] = useState(0);
  const [stockagesLibres, setStockagesLibres] = useState(0);

  // États pour RDC
  const [totalStockagesRDC, setTotalStockagesRDC] = useState(0);
  const [stockagesOccupesRDC, setStockagesOccupesRDC] = useState(0);
  const [stockagesLibresRDC, setStockagesLibresRDC] = useState(0);
  const [infosLibresRDC, setInfosLibresRDC] = useState([]);
  const [infosOccupesRDC, setInfosOccupesRDC] = useState([]);

  // États pour ETAGE
  const [totalStockagesEtg, setTotalStockagesEtg] = useState(0);
  const [stockagesOccupesEtg, setStockagesOccupesEtg] = useState(0);
  const [stockagesLibresEtg, setStockagesLibresEtg] = useState(0);
  const [infosLibresEtg, setInfosLibresEtg] = useState([]);
  const [infosOccupesEtg, setInfosOccupesEtg] = useState([]);

  // États pour CONTENEURS
  const [totalStockagesCont, setTotalStockagesCont] = useState(0);
  const [stockagesOccupesCont, setStockagesOccupesCont] = useState(0);
  const [stockagesLibresCont, setStockagesLibresCont] = useState(0);
  const [infosLibresCont, setInfosLibresCont] = useState([]);
  const [infosOccupesCont, setInfosOccupesCont] = useState([]);

  // 1. Récupération des locations en cours
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${apiUrl}/IHM/api/dashboard.php?loc=enCours`);
        setTotalLocation(response.data.tt || 0);
        console.log("total des locations :", response.data.tt);
      } catch (error) {
        console.error("Erreur lors de la récupération des locations :", error);
      }
    };
    fetchData();
  }, [apiUrl]);

  // 2. Récupération des locations en retard
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${apiUrl}/IHM/api/dashboard.php?loc=retard`);
        setRetardLocation(response.data.retard || 0);
        console.log("total des retards :", response.data.retard);
      } catch (error) {
        console.error("Erreur lors de la récupération des retards :", error);
      }
    };
    fetchData();
  }, [apiUrl]);

  // 3. Récupération des données totales (tout)
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const response = await axios.post(`${apiUrl}/IHM/api/dashboard.php?box=tout`);
        if (response.data) {
          setTotalStockages(response.data.totalStockages || 0);
          setStockagesOccupes(response.data.stockagesOccupes || 0);
          setStockagesLibres(response.data.stockagesLibres || 0);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données totales :", error);
      }
    };
    fetchAllData();
  }, [apiUrl]);

  // 4. Récupération des données RDC
  useEffect(() => {
    // Données libres RDC
    axios
      .get(`${apiUrl}/IHM/api/infoDashboard.php?Libres=RDC`)
      .then((response) => {
        setInfosLibresRDC(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des étagères libres RDC :", error);
      });

    // Données occupées RDC
    axios
      .get(`${apiUrl}/IHM/api/infoDashboard.php?Occupes=RDC`)
      .then((response) => {
        setInfosOccupesRDC(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des étagères occupées RDC :", error);
      });

    // Statistiques RDC
    const fetchStats = async () => {
      try {
        const response = await axios.post(`${apiUrl}/IHM/api/dashboard.php?box=RDC`);
        if (response.data) {
          setTotalStockagesRDC(response.data.totalStockages || 0);
          setStockagesOccupesRDC(response.data.stockagesOccupes || 0);
          setStockagesLibresRDC(response.data.stockagesLibres || 0);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des stats RDC :", error);
      }
    };
    fetchStats();
  }, [apiUrl]);

  // 5. Récupération des données ETAGE
  useEffect(() => {
    // Données libres ETAGE
    axios
      .get(`${apiUrl}/IHM/api/infoDashboard.php?Libres=ETAGE`)
      .then((response) => {
        setInfosLibresEtg(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des étagères libres ETAGE :", error);
      });

    // Données occupées ETAGE
    axios
      .get(`${apiUrl}/IHM/api/infoDashboard.php?Occupes=ETAGE`)
      .then((response) => {
        setInfosOccupesEtg(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des étagères occupées ETAGE :", error);
      });

    // Statistiques ETAGE
    const fetchStats = async () => {
      try {
        const response = await axios.post(`${apiUrl}/IHM/api/dashboard.php?box=etg`);
        if (response.data) {
          setTotalStockagesEtg(response.data.totalStockages || 0);
          setStockagesOccupesEtg(response.data.stockagesOccupes || 0);
          setStockagesLibresEtg(response.data.stockagesLibres || 0);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des stats ETAGE :", error);
      }
    };
    fetchStats();
  }, [apiUrl]);

  // 6. Récupération des données CONTENEURS
  useEffect(() => {
    // Données libres CONTENEURS
    axios
      .get(`${apiUrl}/IHM/api/infoDashboard.php?Libres=CONTENEURS`)
      .then((response) => {
        setInfosLibresCont(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des étagères libres CONTENEURS :", error);
      });

    // Données occupées CONTENEURS
    axios
      .get(`${apiUrl}/IHM/api/infoDashboard.php?Occupes=CONTENEURS`)
      .then((response) => {
        setInfosOccupesCont(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des étagères occupées CONTENEURS :", error);
      });

    // Statistiques CONTENEURS
    const fetchStats = async () => {
      try {
        const response = await axios.post(`${apiUrl}/IHM/api/dashboard.php?box=cont`);
        if (response.data) {
          setTotalStockagesCont(response.data.totalStockages || 0);
          setStockagesOccupesCont(response.data.stockagesOccupes || 0);
          setStockagesLibresCont(response.data.stockagesLibres || 0);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des stats CONTENEURS :", error);
      }
    };
    fetchStats();
  }, [apiUrl]);




  return (
    <>
      {isMobilePortrait && (
          <TabContext value={value}>
            <Box
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px"
              }}
            >
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons={false}
                allowScrollButtonsMobile
                sx={{
                  "& .MuiTabs-flexContainer": {
                    justifyContent: "flex-start",
                  },
                }}
              >
                <Tab label="Fiches" value="1" />
                <Tab label="Mails" value="2" />
                <Tab label="Occupation" value="3" />
                <Tab label="Retards" value="4" />
              
              </TabList>
            </Box>

            <TabPanel value="1" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Fiches stock (j - 30)
                  </div>
                  <DoughnutChartFiche />
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Fiches dem (j - 30)
                  </div>
                  <DoughnutChartFicheDem />
                </div>
              </Box>
            </TabPanel>
            <TabPanel value="2" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Statistiques Mails Stock (j - 30)
                  </div>
                  <MailStatsChart />
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Statistiques Mails Dem (j - 30)
                  </div>
                  <DemMailStatsChart />
                </div>
              </Box>
            </TabPanel>

            <TabPanel value="3" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                
              <OccupationStats
                totalStockages={totalStockages}
                stockagesOccupes={stockagesOccupes}
                stockagesLibres={stockagesLibres}
                totalStockagesRDC={totalStockagesRDC}
                stockagesOccupesRDC={stockagesOccupesRDC}
                stockagesLibresRDC={stockagesLibresRDC}
                infosLibresRDC={infosLibresRDC}
                infosOccupesRDC={infosOccupesRDC}
                totalStockagesEtg={totalStockagesEtg}
                stockagesOccupesEtg={stockagesOccupesEtg}
                stockagesLibresEtg={stockagesLibresEtg}
                infosLibresEtg={infosLibresEtg}
                infosOccupesEtg={infosOccupesEtg}
                totalStockagesCont={totalStockagesCont}
                stockagesOccupesCont={stockagesOccupesCont}
                stockagesLibresCont={stockagesLibresCont}
                infosLibresCont={infosLibresCont}
                infosOccupesCont={infosOccupesCont}
              />


              </Box>
            </TabPanel>

            <TabPanel value="4" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <DashRetard />

                <DashRetard2 />
              </Box>
            </TabPanel>
            
          </TabContext>
      )}
{!isMobilePortrait && (
  <div
    style={{
      padding: "25px",
      display: "flex",
      flexDirection: "column",
      gap: "30px",
      backgroundColor: "#f4f7f9",
    }}
  >
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr", // 2 colonnes égales
        gap: "20px",
      }}
    >
      {/* Colonne 1 : Statistiques */}
      <div
        style={{
          ...cardBaseStyle,
          padding: "20px",
          margin: 0,
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            zIndex: "22",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          Statistiques
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "20px",
          }}
        >
          <div style={{ padding: "0" }}>
            <h3 style={cardTitleStyle}>Fiches stock (j - 30)</h3>
            <DoughnutChartFiche />
          </div>

          <div style={{ padding: "0" }}>
            <h3 style={cardTitleStyle}>Fiches déménagement (j - 30)</h3>
            <DoughnutChartFicheDem />
          </div>

          <div style={{ padding: "0" }}>
            <h3 style={cardTitleStyle}>
              Statistiques Mails Stock (j - 30)
            </h3>
            <MailStatsChart />
          </div>

          <div style={{ padding: "0" }}>
            <h3 style={cardTitleStyle}>
              Statistiques Mails Dem (j - 30)
            </h3>
            <DemMailStatsChart />
          </div>
        </div>
      </div>

      {/* Colonne 2 : Occupations + Retards */}
      <div
        style={{
          ...cardBaseStyle,
          padding: "20px",
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        {/* Occupations */}
        <div>
          <h3
            style={{
              fontWeight: "600",
              zIndex: "22",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            Occupations
          </h3>
          
          <OccupationStats
            totalStockages={totalStockages}
            stockagesOccupes={stockagesOccupes}
            stockagesLibres={stockagesLibres}
            totalStockagesRDC={totalStockagesRDC}
            stockagesOccupesRDC={stockagesOccupesRDC}
            stockagesLibresRDC={stockagesLibresRDC}
            infosLibresRDC={infosLibresRDC}
            infosOccupesRDC={infosOccupesRDC}
            totalStockagesEtg={totalStockagesEtg}
            stockagesOccupesEtg={stockagesOccupesEtg}
            stockagesLibresEtg={stockagesLibresEtg}
            infosLibresEtg={infosLibresEtg}
            infosOccupesEtg={infosOccupesEtg}
            totalStockagesCont={totalStockagesCont}
            stockagesOccupesCont={stockagesOccupesCont}
            stockagesLibresCont={stockagesLibresCont}
            infosLibresCont={infosLibresCont}
            infosOccupesCont={infosOccupesCont}
          />
        </div>

        {/* Retards */}
        <div style={{ 
          ...cardBaseStyle, 
          padding: "15px",
          margin: 0,
        }}>
          <DashRetard />
        </div>
      </div>
    </div>
  </div>
)}
    </>
  );

  
};
